import React from 'react';

import Layout from '../components/Layout';
import Scroll from '../components/Scroll';

import config from '../../config';
import Footer from '../components/Footer';
import Header from '../components/Header';
import ScrollToTop from '../components/ScrollToTop';


import p11 from '../assets/images/game.gif';
import p12 from '../assets/images/game1.gif';
import p13 from '../assets/images/game3.gif';
import p14 from '../assets/images/game2.gif';

const IndexPage = () => (
  <Layout>
    <Header />

    <div className="col-lg-6">
            <a className="portfolio-item" href="#">
              <span className="caption">
                <span className="caption-content">
                  <h2></h2>
                  <p className="mb-0">
                   <b>Enjoy Games with just a click...</b>
                  </p>
                </span>
              </span>
              <img className="img-fluid" src={p11} alt="" />
            </a>


          </div>

   

    





 <section className="content-section bg-primary text-white">
      <div className="container text-center">
        <h2 className="mb-4"></h2>
        <a href="https://paajoelibrary.blogspot.com/p/android-catalogue.html" className="btn btn-xl btn-light mr-4">
         Android Games & iOS Games
        </a>
        <a href="https://www.ea.com/en-gb/games/library/pc-download" className="btn btn-xl btn-dark">
         EA PC Games
        </a>
      </div>
    </section>

    




 <section className="content-section bg-primary text-white">
      <div className="container text-center">
        <h2 className="mb-4"></h2>
        <a href="https://www.gameloft.com/en/" className="btn btn-xl btn-light mr-4">
         Gameloft
        </a>
        <a href="https://play.google.com/store/apps/details?id=com.gameloft.android.ANMP.GloftA8HM&hl=en" className="btn btn-xl btn-dark">
          3D Games
        </a>
      </div>
    </section>


     <section className="content-section bg-primary text-white">
      <div className="container text-center">
        <h2 className="mb-4"></h2>
        <a href="https://www.gametop.com/" className="btn btn-xl btn-light mr-4">
         GameTop
        </a>
        <a href="https://www.origin.com/zaf/en-us/store" className="btn btn-xl btn-dark">
         Origin Games
        </a>
      </div>
    </section>





 <section className="content-section bg-primary text-white">
      <div className="container text-center">
        <h2 className="mb-4"></h2>
        <a href="https://www.gametop.com/" className="btn btn-xl btn-light mr-4">
         GameTop
        </a>
        <a href="https://www.origin.com/zaf/en-us/store" className="btn btn-xl btn-dark">
         Origin Games
        </a>
      </div>
    </section>




     <section className="content-section bg-primary text-white">
      <div className="container text-center">
        <h2 className="mb-4"></h2>
        <a href="https://www.ign.com/" className="btn btn-xl btn-light mr-4">
         IGN
        </a>
        <a href="https://gamefaqs.gamespot.com/" className="btn btn-xl btn-dark">
         Game FAQs
        </a>
      </div>
    </section>


 <section className="content-section" id="portfolio">
      <div className="container">
        <div className="content-section-heading text-center">
          <h3 className="text-secondary mb-0">Browse Smart</h3>
          <img className="img-fluid" src={p12} alt="" />
          <h2 className="mb-5"> Get your games on the Internet Smartly..<i className="fa fa-gamepad fa-spin"></i></h2>
        </div>
        
      </div>
    </section>




   


   <section className="content-section bg-primary text-white">
      <div className="container text-center">
        <h2 className="mb-4"></h2>
        <a href="http://oceanofgames.com/" className="btn btn-xl btn-light mr-4">
         Ocean Of Games
        </a>
        <a href="https://www.skidrowreloaded.com/" className="btn btn-xl btn-dark">
        Skidrow Games
        </a>
      </div>
    </section>




     <section className="content-section bg-primary text-white">
      <div className="container text-center">
        <h2 className="mb-4"></h2>
        <a href="https://www.g2a.com/?gname=user-5daf71f34f63c" className="btn btn-xl btn-light mr-4">
         G2A Games
        </a>
        <a href="https://apps.apple.com/us/genre/ios-games/id6014" className="btn btn-xl btn-dark">
        3D App Store Games
        </a>
      </div>
    </section>




<section className="content-section bg-primary text-white">
      <div className="container text-center">
        <h2 className="mb-4"></h2>
        <a href="https://www.miniclip.com/games/en/#privacy-settings" className="btn btn-xl btn-light mr-4">
         MiniClip
        </a>
        <a href="https://www.addictinggames.com/" className="btn btn-xl btn-dark">
        Addicting Games
        </a>
      </div>
    </section>


    
<section className="content-section bg-primary text-white">
      <div className="container text-center">
        <h2 className="mb-4"></h2>
        <a href="http://www.zylom.com/eu/en/" className="btn btn-xl btn-light mr-4">
         Zylom 
        </a>
        <a href="https://store.steampowered.com/" className="btn btn-xl btn-dark">
        Steam
        </a>
      </div>
    </section>



<section className="content-section bg-primary text-white">
      <div className="container text-center">
        <h2 className="mb-4"></h2>
        <a href="https://www.freeonlinegames.com/" className="btn btn-xl btn-light mr-4">
         Free Online Games
        </a>
        <a href="https://www.kongregate.com/" className="btn btn-xl btn-dark">
        Kongregate
        </a>
      </div>
    </section>


<section className="content-section" id="portfolio">
      <div className="container">
        <div className="content-section-heading text-center">
          <h3 className="text-secondary mb-0">Browse Smartly</h3>
          <img className="img-fluid" src={p13} alt="" />
          <h2 className="mb-5"> Get your games on the Internet Smartly..<i className="fa fa-gamepad fa-spin"></i></h2>
        </div>
        
      </div>
    </section>





<section className="content-section bg-primary text-white">
      <div className="container text-center">
        <h2 className="mb-4"></h2>
        <a href="https://www.gamehouse.com/" className="btn btn-xl btn-light mr-4">
        Game House
        </a>
        <a href="https://wowwiki-archive.fandom.com/wiki/Portal:Main" className="btn btn-xl btn-dark">
       Fandom
        </a>
      </div>
    </section>




     <section className="content-section bg-primary text-white">
      <div className="container text-center">
        <h2 className="mb-4"></h2>
        <a href="https://www.aol.com/games" className="btn btn-xl btn-light mr-4">
         AoL Games
        </a>
        <a href="https://www.aeriagames.com/" className="btn btn-xl btn-dark">
        Aeria Games
        </a>
      </div>
    </section>




<section className="content-section bg-primary text-white">
      <div className="container text-center">
        <h2 className="mb-4"></h2>
        <a href="https://www.battleon.com/" className="btn btn-xl btn-light mr-4">
        Battle on
        </a>
        <a href="http://www.1up.com/" className="btn btn-xl btn-dark">
        1Up
        </a>
      </div>
    </section>


    
<section className="content-section bg-primary text-white">
      <div className="container text-center">
        <h2 className="mb-4"></h2>
        <a href="https://shop.hasbro.com/worldwide" className="btn btn-xl btn-light mr-4">
         Hasbro
        </a>
        <a href="https://www.chess.com/" className="btn btn-xl btn-dark">
        Chess
        </a>
      </div>
    </section>



<section className="content-section bg-primary text-white">
      <div className="container text-center">
        <h2 className="mb-4"></h2>
        <a href="http://www.freeworldgroup.com/" className="btn btn-xl btn-light mr-4">
         Free World Group
        </a>

        <a href= "http://www.flyordie.com/" className="btn btn-xl btn-dark">
       Fly or Die
        </a>
      </div>
    </section>




<section className="content-section" id="portfolio">
      <div className="container">
        <div className="content-section-heading text-center">
          <h3 className="text-secondary mb-0">Browse Smartly</h3>
          <img className="img-fluid" src={p14} alt="" />
          <h2 className="mb-5"> Get your games on the Internet Smartly..<i className="fa fa-gamepad fa-spin"></i></h2>
        </div>
        
      </div>
    </section>





<section className="content-section bg-primary text-white">
      <div className="container text-center">
        <h2 className="mb-4"></h2>
        <a href="http://www.onrpg.com/" className="btn btn-xl btn-light mr-4">
       ONRPG
        </a>
        <a href="https://boardgamegeek.com/" className="btn btn-xl btn-dark">
       Board Game Geek
        </a>
      </div>
    </section>




     <section className="content-section bg-primary text-white">
      <div className="container text-center">
        <h2 className="mb-4"></h2>
        <a href="https://www.games-workshop.com/Home?_requestid=7574603" className="btn btn-xl btn-light mr-4">
         Game Workshop
        </a>
        <a href="https://jayisgames.com/" className="btn btn-xl btn-dark">
        JayisGames
        </a>
      </div>
    </section>




<section className="content-section bg-primary text-white">
      <div className="container text-center">
        <h2 className="mb-4"></h2>
        <a href="https://www.myplaycity.com/" className="btn btn-xl btn-light mr-4">
       MyPlayCity
        </a>
        <a href="https://www.gamezhero.com/" className="btn btn-xl btn-dark">
       GamezHero
        </a>
      </div>
    </section>


    
<section className="content-section bg-primary text-white">
      <div className="container text-center">
        <h2 className="mb-4"></h2>
        <a href="https://www.gamespot.com/" className="btn btn-xl btn-light mr-4">
         Gamespot
        </a>
        <a href="https://www.chess.com/" className="btn btn-xl btn-dark">
        Chess
        </a>
      </div>
    </section>



<section className="content-section bg-primary text-white">
      <div className="container text-center">
        <h2 className="mb-4"></h2>
        <a href="http://gameyard.com/" className="btn btn-xl btn-light mr-4">
         Game Yard
        </a>
        <a href="https://www.gametion.com/" className="btn btn-xl btn-dark">
      Gametion
        </a>
      </div>
    </section>



<section className="content-section" id="portfolio">
      <div className="container">
        <div className="content-section-heading text-center">
          <h3 className="text-secondary mb-0">Browse Smartly</h3>
          <h2 className="mb-5"> Get your games on the Internet Smartly..<i className="fa fa-gamepad fa-spin"></i></h2>
        </div>
        
      </div>
    </section>





<section className="content-section bg-primary text-white">
      <div className="container text-center">
        <h2 className="mb-4"></h2>
        <a href="https://www.pcgamer.com/" className="btn btn-xl btn-light mr-4">
       PC Gamer
        </a>
        <a href="http://absolutist.com/" className="btn btn-xl btn-dark">
      Absolutist
        </a>
      </div>
    </section>




     <section className="content-section bg-primary text-white">
      <div className="container text-center">
        <h2 className="mb-4"></h2>
        <a href="https://gamecolony.com/" className="btn btn-xl btn-light mr-4">
         Game Colony
        </a>
        <a href="https://www.matrixgames.com/" className="btn btn-xl btn-dark">
        Matrix Games
        </a>
      </div>
    </section>




<section className="content-section bg-primary text-white">
      <div className="container text-center">
        <h2 className="mb-4"></h2>
        <a href="http://pokedream.com/games/" className="btn btn-xl btn-light mr-4">
      Poke Dream
        </a>
        <a href="http://arcadecontrols.com/arcade.htm" className="btn btn-xl btn-dark">
       Game Grafix
        </a>
      </div>
    </section>


    
<section className="content-section bg-primary text-white">
      <div className="container text-center">
        <h2 className="mb-4"></h2>
        <a href="https://www.download-free-games.com/" className="btn btn-xl btn-light mr-4">
         Download-free-games
        </a>
        <a href="http://freegamepick.net/en/?utm_campaign=brand-acquisition" className="btn btn-xl btn-dark">
        Free Game Pick
        </a>
      </div>
    </section>



<section className="content-section bg-primary text-white">
      <div className="container text-center">
        <h2 className="mb-4"></h2>
        <a href="https://www.arkadium.com/" className="btn btn-xl btn-light mr-4">
         Arkadium
         </a>
        <a href="https://www.twingalaxies.com/" className="btn btn-xl btn-dark">
       Twin Galaxies
        </a>


        <a href="https://www.pogo.com/" className="btn btn-xl btn-dark">
       Pogo
        </a>
      </div>
    </section>











    {/* <section id="contact" className="map">
      <iframe
        width="100%"
        height="100%"
        frameborder="0"
        scrolling="no"
        marginheight="0"
        marginwidth="0"
        src="https://maps.google.com/maps?f=q&amp;source=s_q&amp;hl=en&amp;geocode=&amp;q=Twitter,+Inc.,+Market+Street,+San+Francisco,+CA&amp;aq=0&amp;oq=twitter&amp;sll=28.659344,-81.187888&amp;sspn=0.128789,0.264187&amp;ie=UTF8&amp;hq=Twitter,+Inc.,+Market+Street,+San+Francisco,+CA&amp;t=m&amp;z=15&amp;iwloc=A&amp;output=embed"
      ></iframe>
      <br />
      <small>
        <a href="https://maps.google.com/maps?f=q&amp;source=embed&amp;hl=en&amp;geocode=&amp;q=Twitter,+Inc.,+Market+Street,+San+Francisco,+CA&amp;aq=0&amp;oq=twitter&amp;sll=28.659344,-81.187888&amp;sspn=0.128789,0.264187&amp;ie=UTF8&amp;hq=Twitter,+Inc.,+Market+Street,+San+Francisco,+CA&amp;t=m&amp;z=15&amp;iwloc=A"></a>
      </small>
    </section> */}

    <ScrollToTop />
    <Footer />
  </Layout>
);

export default IndexPage;
